<template lang="pug">
  .relative(
    ref="swiper"
    v-swiper="swiperOptions"
    :auto-destroy="false"
    @slideChangeTransitionEnd="onSlideChange"
  )
    .swiper-wrapper.items-stretch
      .swiper-slide.text-center(v-for="(stage, index) in stages" :key="index")
        .h-full.flex.flex-col.justify-between(class="px-8 md:px-12")
          .h-20.flex.flex-col.justify-center
            h2.text-xl.font-bold.leading-none(v-html="formatTohtml(stage.name)")
          .mb-8(class="hidden lg:block")
            .thumbnail.max-w-xs.mx-auto
              img(:src="stage.thumbnailImageSrc")
          p.description.my-auto(v-html="formatTohtml(stage.description)")
          .my-4(class="md:my-8")
            hr.mx-auto.opacity-25(class="w-10/12 lg:w-full")
            .item.text-left.mt-6
              template(v-if="stage.item")
                template(v-if="stage.part.match('emptyBox')")
                  .icon.text-foul
                    v-fa(size="2x" icon="sad-tear")
                  .text
                    span この場所でマグロボパーツは
                    span 見つからなかった･･･
                template(v-else)
                  .icon.text-bolt
                    v-fa(size="2x" icon="smile-wink")
                  .text
                    span この場所でマグロボパーツ
                    span.inline-block
                      span.text-bolt 【{{ stage.item.name }}】
                      | を
                      span 見つけた。
              template(v-else)
                .icon.text-bolt
                  v-fa(size="2x" icon="exclamation-triangle")
                .text
                  span この場所でマグロボパーツは
                  span まだ見つかっていない。
          .text-center
            router-link(class="w-48 router-link" :to="`/stage/${index + 1}`") 
              template(v-if="stage.item") もう一度施設をみる
              template(v-else) 探索する
    .navigation
      .button-prev
        v-fa(size="2x" icon="chevron-left")
      .button-next
        v-fa(size="2x" icon="chevron-right")
</template>
<style lang="sass" scoped>
.swiper-slide
  @apply h-auto
.swiper-slide-active
  @apply z-10
.thumbnail
  box-shadow: theme('colors.cyan') 0 0 4px, theme('colors.cyan') 0 0 24px
  @apply overflow-hidden rounded
h2, p
  ::v-deep > span
    @apply inline-block
.navigation
  @apply absolute z-10 inset-x-0 mx-4 flex justify-between items-center
  top: 50%
  pointer-events: none
  @screen lg
    @apply -mt-24
.button-prev,
.button-next
  pointer-events: auto

.description
  @apply text-sm mx-auto w-10/12
  @screen ls
    @apply text-xs
  @screen md
    @apply w-full text-base

.item
  @apply inline-flex items-center leading-tight
  .icon
    @apply pr-2
  .text
    @apply text-xs inline-flex flex-wrap flex-col
    @screen pt
      @screen md
        @apply flex-row
    @screen xl
      @apply flex-row
</style>

<script>
export default {
  props: {
    current: {
      type: Number,
      default: 1
    },
    stages: {
      type: Array
    }
  },
  data() {
    return {
      swiperOptions: {
        initialSlide: this.current,
        slidesPerView: 1,
        loop: true,
        speed: 500,
        grabCursor: true,
        preventClicks: false,
        navigation: {
          nextEl: ".button-next",
          prevEl: ".button-prev"
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true
        }
      }
    };
  },
  watch: {
    current(value) {
      this.$swiper.slideTo(value, 0);
    }
  },
  methods: {
    onSlideChange() {
      if (this.$swiper.realIndex + 1 != this.current) {
        this.$emit("slideChange", this.$swiper.realIndex + 1);
      }
    }
  }
};
</script>
